import { toast } from 'react-toastify';

import PriceTargetsAccordionItem from './PriceTargetsAccordionItem';
import { AdvancedSettings } from '../../Portfolio/AdvancedSettings';
import { DELETE_STRATEGY_ASSET_TARGET } from '../../../../http/apollo-queries';
import { Icon } from '../../../UI';
import { useModalContext } from '../../../../context/Modal';
import { useMutation } from '@apollo/client';
import { useUserStrategies } from '../../../../context/UserStrategies';

import { IStrategyAsset, IStrategyAssetTarget } from '../../../../types/model';
import { Currency } from '../../../../types/common';

const PRICE_TARGETS_COLUMNS = [
  '',
  'End date',
  'Stop Profit',
  'S.P Variation',
  'Stop Loss',
  'S.L Variation',
];

const PriceTargetsAccordion = ({
  assetData,
  className = '',
  currency,
  width,
}: {
  assetData: IStrategyAsset;
  className?: string;
  currency: Currency['code'];
  width: number;
}) => {
  const {
    asset: { history },
    entryPrice,
  } = assetData;
  const { dispatch: dispatchModal } = useModalContext();
  const { refetch: refetchStrategies } = useUserStrategies();

  const [deleteStrategyAssetTarget] = useMutation(
    DELETE_STRATEGY_ASSET_TARGET,
    {
      onCompleted: () => refetchStrategies(),
      onError: () => {
        toast.error(
          'There was an error processing your request, please try again'
        );
      },
    }
  );

  return (
    <div className={className}>
      {assetData.strategyAssetTargets!.items.length > 0 &&
        PRICE_TARGETS_COLUMNS.map((title, index) => (
          <div
            key={index}
            className={`
              h-10
              flex
              items-center
              border-grey-10
              border-t-1
              ${(index === 3 || index === 5) && 'col-span-2 pl-5'}
              font-medium
              text-xs
            `}
          >
            {title}
          </div>
        ))}
      {assetData.strategyAssetTargets!.items.map((target, i) => (
        <PriceTargetsAccordionItem
          key={target.id}
          currency={currency}
          lastPrice={history[0]?.[currency.toLocaleLowerCase()] ?? 0}
          name={`S ${i + 1}`}
          target={target}
          width={width}
          deleteTarget={(id: string | undefined) =>
            deleteStrategyAssetTarget({
              variables: {
                strategyAssetTargetId: id,
              },
            })
          }
        />
      ))}
    </div>
  );
};

export default PriceTargetsAccordion;
